import React, { useState } from "react";

const Project = () => {
  const [projects, setProjects] = useState([]);
  const [isContentVisible, setIsContentVisible] = useState(false);
  const [isEditing, setIsEditing] = useState(false);

  // Handle input changes for editable fields
  const handleInputChange = (index, field, value) => {
    const updatedProjects = [...projects];
    updatedProjects[index][field] = value;
    setProjects(updatedProjects);
  };

  // Add a new project entry
  const addProject = () => {
    setProjects([
      ...projects,
      {
        projectName: "",
        projectLink: "",
        timeline: "",
        description: "",
      },
    ]);
  };

  // Delete a project entry
  const deleteProject = (index) => {
    const updatedProjects = projects.filter((_, i) => i !== index);
    setProjects(updatedProjects);
  };

  // Save changes (stub function for now, add your logic here)
  const saveProjects = () => {
    console.log("Projects saved:", projects);
    setIsEditing(false);
  };

  return (
    <div className="flex flex-col w-full mr-11 bg-white rounded-3xl mt-4 h-full">
      <div className="flex justify-between items-center">
        <h1 className="font-bold text-xl m-3 ml-9 mt-4">Projects</h1>
        <button
          className="m-3 mr-7 text-[#0077af] text-xl focus:outline-none"
          onClick={() => setIsContentVisible(!isContentVisible)}
        >
          {isContentVisible ? "\u25B2" : "\u25BC"} {/* Arrow Up or Down */}
        </button>
      </div>

      {isContentVisible && (
        <>
          <div className="grid grid-cols-1 gap-4 m-10 mt-4">
            {projects.map((project, index) => (
              <div
                key={index}
                className="grid grid-cols-1 gap-4 p-4 border rounded shadow-sm"
              >
                <div>
                  <label className="text-gray-500 font-semibold">Project Name</label>
                  {isEditing ? (
                    <input
                      type="text"
                      value={project.projectName || ""}
                      onChange={(e) =>
                        handleInputChange(index, "projectName", e.target.value)
                      }
                      className="border rounded p-2 w-full mt-1"
                      placeholder="Enter project name"
                    />
                  ) : (
                    <p className="text-black font-semibold mt-1">
                      {project.projectName || "Not Provided"}
                    </p>
                  )}
                </div>

                <div>
                  <label className="text-gray-500 font-semibold">Project Link</label>
                  {isEditing ? (
                    <input
                      type="text"
                      value={project.projectLink || ""}
                      onChange={(e) =>
                        handleInputChange(index, "projectLink", e.target.value)
                      }
                      className="border rounded p-2 w-full mt-1"
                      placeholder="Enter project link"
                    />
                  ) : (
                    <a
                      href={project.projectLink || "#"}
                      className="text-blue-600 mt-1"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      {project.projectLink || "Not Provided"}
                    </a>
                  )}
                </div>

                <div>
                  <label className="text-gray-500 font-semibold">Timeline</label>
                  {isEditing ? (
                    <input
                      type="text"
                      value={project.timeline || ""}
                      onChange={(e) =>
                        handleInputChange(index, "timeline", e.target.value)
                      }
                      className="border rounded p-2 w-full mt-1"
                      placeholder="Enter timeline"
                    />
                  ) : (
                    <p className="text-black font-semibold mt-1">
                      {project.timeline || "Not Provided"}
                    </p>
                  )}
                </div>

                <div>
                  <label className="text-gray-500 font-semibold">Description</label>
                  {isEditing ? (
                    <textarea
                      value={project.description || ""}
                      onChange={(e) =>
                        handleInputChange(index, "description", e.target.value)
                      }
                      className="border rounded p-2 w-full mt-1"
                      rows="3"
                      placeholder="Enter description"
                    ></textarea>
                  ) : (
                    <p className="text-black font-semibold mt-1">
                      {project.description || "Not Provided"}
                    </p>
                  )}
                </div>

                {isEditing && (
                  <button
                    onClick={() => deleteProject(index)}
                    className="text-red-600 hover:text-red-800 flex text-lg mt-2"
                  >
                    🗑️ Delete
                  </button>
                )}
              </div>
            ))}
          </div>

          <div className="flex justify-between items-center px-10 mb-6">
            <button
              onClick={addProject}
              className="bg-[#0077af] text-white px-4 py-2 rounded hover:bg-[#005f80]"
            >
              Add Project
            </button>
            <button
              onClick={() => setIsEditing(!isEditing)}
              className={`px-4 py-2 rounded ${
                isEditing
                  ? "bg-gray-600 text-white"
                  : "bg-[#0077af] text-white hover:bg-white hover:text-[#0077af] hover:border-2 hover:border-[#0077af]"
              }`}
            >
              {isEditing ? "Cancel Edit" : "Edit"}
            </button>
            {isEditing && (
              <button
                onClick={saveProjects}
                className="bg-green-600 text-white px-4 py-2 rounded hover:bg-green-700"
              >
                Save Changes
              </button>
            )}
          </div>
        </>
      )}
    </div>
  );
};

export default Project;
